import React from "react";
import CommonManagementSection from "./CommonManagementSection";
class CommunitySection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }

    render() {
        return (
            <div id='community' className='lndSolutionEachSec'>
                <div className='lndSoltopHead'>
                    <h3>Communities</h3>
                    <p>Empower your community with one-window collaboration for Managing Members, Projects, Fund Raise, Studio, and other activities. Create your own Ecosystem - with jobs, learnings, development projects and productive exchange of ideas.</p>
                </div>
                <div className='specialGridCol'>
                    <CommonManagementSection sectionType={"COMMUNITIES"} />

                    <div className='lndSPCol lndSolRightInfoBlk'>
                        <h4>Embrace Scalability, Eliminate Repetitive Tasks and Manual updates</h4>
                        <ul className='lndSolLists'>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolCommIco-1.svg"} alt='' /></figure>
                                <div>
                                    <h5>Manage members</h5>
                                    <p>Receive applications, manage permissions</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolCommIco-2.svg"} alt='' /></figure>
                                <div>
                                    <h5>Assign Multiple Admins</h5>
                                    <p>Allocation of tasks at the community and project level</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolCommIco-3.svg"} alt='' /></figure>
                                <div>
                                    <h5>Manage Community Profile</h5>
                                    <p>Narrate your story “Who We Are” and “What We Do”</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolCommIco-4.svg"} alt='' /></figure>
                                <div>
                                    <h5>Manage Projects</h5>
                                    <p>Invite global participants</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolCommIco-5.svg"} alt='' /></figure>
                                <div>
                                    <h5>Peer Learning and Inspiration</h5>
                                    <p>Refer to the past project activities for long term recall.</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default CommunitySection;